// removed by extract-text-webpack-plugin
module.exports = {"pdpFolderItem":"PdpFolderItem-style__pdpFolderItem__15p_u"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Favorites/PdpFolderItem-style.scss
// module id = 3056
// module chunks = 4